import BarCharts from "../../Complaint/ComplaintCharts/VerticalBarChart.js";
import { axInst } from "../../../Components/Login/Service";
import { useQueries } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

/* ---------------- API ---------------- */
const DealerCharts = async (body, apiEndpoint) => {
  try {
    const res = await axInst.post(apiEndpoint, body);
    const { HCV, ILMCV, CV } = res.data;

    const formatChartData = (data) =>
      data && Object.keys(data).length
        ? {
            keyData: Object.keys(data),
            valData: Object.values(data),
          }
        : null;

    return {
      hcvData: formatChartData(HCV),
      ilmcvData: formatChartData(ILMCV),
      cvData: formatChartData(CV),
    };
  } catch (error) {
    console.error("Error fetching chart data:", error);
    throw error;
  }
};

export const DealerReviewCharts = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const apiEndpoints = [
    "dealer-review/fleetedge_status",
    "dealer-review/mileage_sarathi",
  ];

  const queries = useQueries({
    queries: apiEndpoints.map((endpoint) => ({
      queryKey: [endpoint, submitted],
      queryFn: () => DealerCharts(data, endpoint),
      cacheTime: 0,
      staleTime: 0,
    })),
  });

  const isFetching = queries.some((q) => q.isFetching);
  const isError = queries.some((q) => q.isError);

  /* ---------- DATA VALIDATION ---------- */
  const hasValidCharts = (chartData) =>
    chartData &&
    Object.values(chartData).some(
      (d) => d && d.keyData?.length && d.valData?.length,
    );

  /* ---------- EMPTY STATE ---------- */
  const NoData = ({ text }) => (
    <div className="grid items-center justify-center w-full h-full">
      <p>{text}</p>
    </div>
  );

  return (
    <div className="relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}

      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}

      {!isFetching && !isError && (
        <>
          {/* ---------- FLEET EDGE ---------- */}
          {queries[0]?.data && (
            <div className="shadow-lg rounded-lg p-2 bg-white opacity-85">
              <h1 className="p-1 font-semibold">
                Fleet Edge Subscription Renewal (%)
              </h1>

              {!hasValidCharts(queries[0].data) ? (
                <NoData text="Data Not Available" />
              ) : (
                <div
                  className={`md:flex block mt-4 ${
                    Object.values(queries[0].data).filter((d) => d).length === 1
                      ? "justify-center"
                      : "justify-between"
                  }`}
                >
                  {["hcvData", "ilmcvData", "cvData"]
                    .filter((type) => queries[0].data[type]?.keyData?.length)
                    .map((type, idx, arr) => (
                      <div
                        key={idx}
                        className={`flex-1 ${arr.length === 1 ? "w-full" : ""}`}
                      >
                        <WaterMark />
                        <BarCharts
                          line={false}
                          color={
                            type === "hcvData"
                              ? "#5796FD"
                              : type === "ilmcvData"
                                ? "#31BAB5"
                                : "#59AA5F"
                          }
                          xaxisdata={queries[0].data[type].keyData}
                          yaxisdata={queries[0].data[type].valData}
                          heading={
                            type === "hcvData"
                              ? "HCV Trucks"
                              : type === "ilmcvData"
                                ? "ILMCV Trucks"
                                : "CV Pass"
                          }
                          barWidth={6}
                          barOpacity={0.4}
                          headingColor="#4f4f4f"
                          headingFont="16"
                        />
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}

          {/* ---------- MILEAGE SAARATHI ---------- */}
          {queries[1]?.data && (
            <div className="shadow-lg rounded-lg p-2 bg-white opacity-85 mt-2">
              <h1 className="font-bold">
                Mileage Saarathi Status (Retail till last day of Month)
              </h1>

              {!hasValidCharts(queries[1].data) ? (
                <NoData text="Data Not Available" />
              ) : (
                <div
                  className={`md:flex block mt-4 ${
                    Object.values(queries[1].data).filter((d) => d).length === 1
                      ? "justify-center"
                      : "justify-between"
                  }`}
                >
                  {["hcvData", "ilmcvData", "cvData"]
                    .filter((type) => queries[1].data[type]?.keyData?.length)
                    .map((type, idx, arr) => (
                      <div
                        key={idx}
                        className={`flex-1 ${arr.length === 1 ? "w-full" : ""}`}
                      >
                        <WaterMark />
                        <BarCharts
                          line={false}
                          color={
                            type === "hcvData"
                              ? "#5796FD"
                              : type === "ilmcvData"
                                ? "#31BAB5"
                                : "#59AA5F"
                          }
                          xaxisdata={queries[1].data[type].keyData}
                          yaxisdata={queries[1].data[type].valData}
                          heading={
                            type === "hcvData"
                              ? "HCV Trucks"
                              : type === "ilmcvData"
                                ? "ILMCV Trucks"
                                : "CV Pass"
                          }
                          barWidth={4}
                          barOpacity={0.4}
                          headingColor="#4f4f4f"
                          headingFont="16"
                        />
                      </div>
                    ))}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};
